import React from 'react'

import { type DocumentImage } from './hooks/useFetchDocumentImages'

export const isEnabledTransitionContext = React.createContext(false)

export const onCardClickContext = React.createContext<
  ((documentImage: DocumentImage) => void) | undefined
>(undefined)
